<div class="product-catalog-container">
  <!-- Sticky Header -->
  <div class="catalog-header">
    <div class="order-summary" *ngIf="selectedCustomer">
      <div class="customer-name">
        {{ selectedCustomer.name }}
      </div>
      <div class="cart-details">
        <strong>Nos:</strong> {{ totalItems }} | ₹{{ totalAmount | number:'1.2-2' }}
      </div>
    </div>

    <!-- Search Input -->
    <app-search-bar [placeholder]="'Search Products'"
                    (search)="searchTerm = $event; searchProducts()">
    </app-search-bar>
  </div>

  <!-- Scrollable Product Cards -->
  <div class="product-catalog">
    <mat-card *ngFor="let product of filteredProducts; trackBy: trackByProductId"
              (click)="addToCart(product)"
              class="product-card" [ngClass]="{'selected': isProductInCart(product)}">
      <div class="card-content">
        <div class="product-image" (click)="openImagePopup($event, product.image)">
          <img *ngIf="product.image" [src]="'data:image/png;base64,' + product.image" alt="Product Image" />
          <div *ngIf="!product.image" class="placeholder">
            {{ product.name[0] | uppercase }}
          </div>
        </div>

        <div class="product-info">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-price">Price: ₹{{ product.list_price | number:'1.2-2' }}</div>
          <div class="product-mrp">MRP: ₹{{ product.mrp | number:'1.2-2' }}</div>

          <div class="product-actions">
            <div *ngIf="isProductInCart(product)" class="quantity-controls">
              <button (click)="$event.stopPropagation()" (mousedown)="decreaseQuantity(product); $event.preventDefault()">-</button>
              <input type="text" inputmode="numeric" pattern="[0-9]*" [attr.data-product-id]="product.id" [(ngModel)]="getSelectedProduct(product).quantity" class="quantity-input" #quantityInput [attr.autofocus]="justFocusedProductId === product.id ? true : null" />
              <button (click)="$event.stopPropagation()" (mousedown)="increaseQuantity(product); $event.preventDefault()"
              
              >+</button>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>
